/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ caseNumber: NonNullable<unknown>, licensePlate: NonNullable<unknown> }} Calendar_Event_Case_LineInputs */

const en_calendar_event_case_line = /** @type {(inputs: Calendar_Event_Case_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Case ${i?.caseNumber} · ${i?.licensePlate}`)
};

const pt_br2_calendar_event_case_line = /** @type {(inputs: Calendar_Event_Case_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caso ${i?.caseNumber} · ${i?.licensePlate}`)
};

/**
* | output |
* | --- |
* | "Case {caseNumber} · {licensePlate}" |
*
* @param {Calendar_Event_Case_LineInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const calendar_event_case_line = /** @type {((inputs: Calendar_Event_Case_LineInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Event_Case_LineInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_event_case_line(inputs)
	return pt_br2_calendar_event_case_line(inputs)
});